export default __webpack_public_path__ + "static/media/LAS0400.34I-30404_-17562_0.58ab52b9.jpg";